import { render, staticRenderFns } from "./sellers-v2.tab.vue?vue&type=template&id=7b835334&scoped=true"
import script from "./sellers-v2.tab.vue?vue&type=script&lang=js"
export * from "./sellers-v2.tab.vue?vue&type=script&lang=js"
import style0 from "./sellers-v2.tab.vue?vue&type=style&index=0&id=7b835334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b835334",
  null
  
)

export default component.exports